import { render, staticRenderFns } from "./TeacherForm.vue?vue&type=template&id=42c8c607&scoped=true"
import script from "./TeacherForm.vue?vue&type=script&lang=js"
export * from "./TeacherForm.vue?vue&type=script&lang=js"
import style0 from "./TeacherForm.vue?vue&type=style&index=0&id=42c8c607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8c607",
  null
  
)

export default component.exports